import { scroller } from "react-scroll";

export function scrollToFarmSection(section, options = {}) {
  const navigationHeight = document.querySelector(".FarmNavigationShell")?.offsetHeight || 80;
  scroller.scrollTo(section, {
    duration: 650,
    smooth: true,
    offset: -navigationHeight - 16,
    ...options,
  });
}
